import { environment } from 'src/environments/environment';
import { CloudPlan } from '../models/cloud-plan.model';
import { CloudVendor } from '../models/cloud-vendor.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupOptions } from '../interfaces/popup.interface';
import { EnvironmentFormRequest } from '../paid-subscription/interfaces/environment-form-request.interface';
import { CloudVendorLower } from '../paid-subscription/types/cloud-vendor-lower.type';
import { OperatingSystemLower } from '../paid-subscription/types/operating-system-lower.type';
import { EnvironmentType } from '../paid-subscription/types/environment-type';
import { HttpErrorResponse } from '@angular/common/http';
import StringHelper from './string-helper';
import { ConfigureSingleEnvironment } from '../types/environment.type';
import { Router } from '@angular/router';
import {  PlanType } from '../enums/plan.enum';
import validEmails from '../../assets/config.json'

export default class Helper {

    static getLicenseType(cloudPlan: CloudPlan) {
        if (this.isCloudPlanPerpetual(cloudPlan))
            return 'perpetual';

        if (this.isCloudPlanAnnual(cloudPlan))
            return 'annual';

        return null;
    }

    static generateGenericEnvironmentObject(environmentName: string, environmentType: EnvironmentType, cloudVendor: CloudVendorLower, operatingSystem: OperatingSystemLower, cloudRegion: string, serverProfile: string, reservedMachiens: number) {
        return {
            environmentName: environmentName,
            environmentType: environmentType,
            cloudVendor: cloudVendor,
            operatingSystem: operatingSystem,
            cloudRegion: cloudRegion,
            serverProfile: serverProfile,
            reservedMachines: reservedMachiens,
        } as EnvironmentFormRequest;
    }

    static isCloudPlanPerpetual(cloudPlan: CloudPlan) {
        return cloudPlan.title.toLowerCase().search('perpetual') != -1;
    }

    static isCloudPlanAnnual(cloudPlan: CloudPlan) {
        return cloudPlan.title.toLowerCase().search('annual') != -1;
    }

    static isCloudPlanSupport(cloudPlan: CloudPlan) {
        let planName = cloudPlan.title.toLowerCase();
        return planName.search('support') != -1 && !this.isCloudPlanPerpetual(cloudPlan);
    }

    static isCloudPlanFreeTrial(cloudPlan: CloudPlan) {
        return cloudPlan.title.toLowerCase().search('free') != -1;
    }

    static isPlanNonHosted(planType:string){
        return planType == PlanType.NonHosted
    }

    static getCloudPlanTypeForLicenses(cloudPlan: CloudPlan) {
        if (Helper.isCloudPlanAnnual(cloudPlan))
            return 'annual';
        if (Helper.isCloudPlanPerpetual(cloudPlan))
            return 'perpetual';
        return null;
    }

    static isLicensingSchemeClientServer(licensingScheme: string) {
        return licensingScheme === 'client-server';
    }

    static isLicensingSchemeServerOnly(licensingScheme: string) {
        return licensingScheme === 'server-only';
    }

    static getSupportEmail(): string {
        return environment.constants.support_email;
    }

    static getSalesEmail(): string {
        return environment.constants.sales_email;
    }

    static isVendorAWS(cloudVendor: CloudVendor): boolean {
        return cloudVendor?.vendorName === 'aws';
    }

    static isVendorAzure(cloudVendor: CloudVendor): boolean {
        return cloudVendor?.vendorName === 'azure';
    }

    static getVendorDisplayName(vendorIdentity: string): string {
        switch (vendorIdentity.toLowerCase()) {
            case "aws":
                return "AWS";
            case "azure":
                return "Azure";

            default:
                return "";
        }
    }

    static getVendor(vendorName: string): CloudVendor | null {

        if (!vendorName) return null;

        const vendors: Record<string, { id: number; name: string }> = {
            azure: { id: 1, name: "Azure" },
            aws: { id: 2, name: "AWS" },
        };

        const vendorInfo = vendors[vendorName.toLowerCase()];
        return vendorInfo ? new CloudVendor(vendorInfo.id, vendorInfo.name, vendorName.toLowerCase()) : null;
    }


    public static get azureVendorName(): string {
        return 'azure';
    }

    public static get awsVendorName(): string {
        return 'aws';
    }

    public static resolveErrorMessage(err) {

        if (err.status === 0) {
            return "An unexpected error occurred";
        }
        
        if (err.error) {
            if (err.error.errorMessage) return err.error.errorMessage;
            if (err.error.message) return err.error.message;
            if (typeof err.error === 'object') return err.message;
            return err.error;
        }

        if (err.errorMessage) {
            return err.errorMessage
        }

        if (typeof err === 'object') {
            return "An unexpected error occurred";
        }

        if (err.message) return err.message;
        return err;
    }

    static configurePopup(popup: NgbModalRef, options: PopupOptions) {
        const { title, message, btnTitle, valueProcessor, viewRadioBtn, viewInput, viewCancelBtn, viewCrossBtn, viewLink, link, linkMessage, placeholder, pattern, viewSalesMessage, salesMessage, salesLink, btnTitleColor } = options;
        popup.componentInstance.title = title || 'Confirm';
        popup.componentInstance.message = message || 'Are you sure?';
        popup.componentInstance.btnTitle = btnTitle || 'Confirm';
        popup.componentInstance.viewRadioBtn = viewRadioBtn || false;
        popup.componentInstance.viewInput = viewInput || false;
        popup.componentInstance.viewCancelBtn = viewCancelBtn || (viewCancelBtn == undefined);
        popup.componentInstance.viewCrossBtn = viewCrossBtn || (viewCrossBtn == undefined);
        popup.componentInstance.viewLink = viewLink || false;
        popup.componentInstance.link = link || "https://www.alachisoft.com/company/contact-us.html";
        popup.componentInstance.linkMessage = linkMessage || "";
        popup.componentInstance.placeholder = placeholder || "";
        popup.componentInstance.pattern = pattern || null;
        popup.componentInstance.getValue.subscribe(valueProcessor || (() => { }));
        popup.componentInstance.viewSalesMessage = viewSalesMessage || false;
        popup.componentInstance.salesMessage = salesMessage || "";
        popup.componentInstance.salesLink = salesLink || "";
        popup.componentInstance.btnTitleColor = btnTitleColor || 'btn-primary'
    }

    static formatString(str: string, ...args: any[]): string {
        return str.replace(/{(\d+)}/g, (match, number) => {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    }

    static isAlachisoftEmail(emails:string[], userEmail):boolean{
       return emails.some((email)=> userEmail.toLowerCase().endsWith(email))
    }
}
